import React from "react";
import { Navigate } from "react-router-dom";

// Admin Sayfaları - HarmanaGEL
import IlanYonetimi from "../pages/Admin/IlanYonetimi/index";
import KategoriYonetimi from "../pages/Admin/KategoriYonetimi/index";
import KategoriOzellikYonetimi from "../pages/Admin/KategoriOzellikYonetimi/index";
import MagazaYonetimi from "../pages/Admin/MagazaYonetimi/index";
import SiparisYonetimi from "../pages/Admin/SiparisYonetimi/index";
import TeslimatYonetimi from "../pages/Admin/TeslimatYonetimi/index";
import ParaCekmeTalepleri from "../pages/Admin/ParaCekmeTalepleri/index";
import KullaniciCuzdanlari from "../pages/Admin/KullaniciCuzdanlari/index";
import CuzdanHareketleri from "../pages/Admin/CuzdanHareketleri/index";
import IadeTalepleri from "../pages/Admin/IadeTalepleri/index";
import SliderYonetimi from "../pages/Admin/SliderYonetimi/index";
import ReklamYonetimi from "../pages/Admin/ReklamYonetimi/index";
import IletisimMesajlari from "../pages/Admin/IletisimMesajlari/index";
import SertifikaTanimlari from "../pages/Admin/SertifikaTanimlari/index";
import MezatYonetimi from "../pages/Admin/MezatYonetimi/index";
import KullaniciSertifikalari from "../pages/Admin/KullaniciSertifikalari/index";
import IlanDegerlemeleri from "../pages/Admin/IlanDegerlemeleri/index";
import KullaniciHaklari from "../pages/Admin/KullaniciHaklari/index";
import BlogYonetimi from "../pages/Admin/BlogYonetimi/index";
import CiftciBilgiMenuleri from "../pages/Admin/CiftciBilgiMenuleri/index";
import HaberKaynaklari from "../pages/Admin/HaberKaynaklari/index";
import HaberYonetimi from "../pages/Admin/HaberYonetimi/index";
import AktivasyonAnalizi from "../pages/Admin/AktivasyonAnalizi/index";
import EtkilesimRaporu from "../pages/Admin/EtkilesimRaporu/index";
import OturumRaporu from "../pages/Admin/OturumRaporu/index";
import Moderatorler from "../pages/Admin/Moderatorler/index";
import Paketler from "../pages/Admin/Paketler/index";
import KurbanSiparisYonetimi from "../pages/Admin/KurbanSiparisYonetimi/index";
import OdemeYonetimi from "../pages/Admin/OdemeYonetimi/index";
import FaturaBilgileri from "../pages/Admin/FaturaBilgileri/index";
import KullaniciBankaBilgileri from "../pages/Admin/KullaniciBankaBilgileri/index";
import EngelListesi from "../pages/Admin/EngelListesi/index";
import IlanTeklifleri from "../pages/Admin/IlanTeklifleri/index";
import DegerlemeTalepleri from "../pages/Admin/DegerlemeTalepleri/index";
import HizmetOnayBasvurulari from "../pages/Admin/HizmetOnayBasvurulari/index";
import HizmetTalebiGir from "../pages/Admin/HizmetTalebiGir/index";
import YorumYonetimi from "../pages/Admin/YorumYonetimi/index";
import SikayetYonetimi from "../pages/Admin/SikayetYonetimi/index";
import BildirimGonder from "../pages/Admin/BildirimGonder/index";
import OdemeLoglari from "../pages/Admin/OdemeLoglari/index";
import IlanFiyatLog from "../pages/Admin/IlanFiyatLog/index";
import IlanGoruntulenmeLog from "../pages/Admin/IlanGoruntulenmeLog/index";
import KurbanlikHayvanListesi from "../pages/Admin/KurbanlikHayvanListesi/index";
import BildirimLoglari from "../pages/Admin/BildirimLoglari/index";
import MezatTeklifleri from "../pages/Admin/MezatTeklifleri/index";
import SiparisDetaylari from "../pages/Admin/SiparisDetaylari/index";
import KurbanlikHisseFiyatlari from "../pages/Admin/KurbanlikHisseFiyatlari/index";
import SistemAyarları from "../pages/Admin/SistemAyarları/index";
import SSSYonetimi from "../pages/Admin/SSSYonetimi/index";
import KullaniciKategoriHaklari from "../pages/Admin/KullaniciKategoriHaklari/index";
import SayfaIcerikleri from "../pages/Admin/SayfaIcerikleri/index";
import KurumsalBilgiler from "../pages/Admin/KurumsalBilgiler/index";
import HizmetSektorleri from "../pages/Admin/HizmetSektorleri/index";
import IsletmeHizmetleri from "../pages/Admin/IsletmeHizmetleri/index";
import Uzmanlar from "../pages/Admin/Uzmanlar/index";
import UzmanDegerlendirmeleri from "../pages/Admin/UzmanDegerlendirmeleri/index";
import BilgiVideolari from "../pages/Admin/BilgiVideolari/index";
import MagazaSorulari from "../pages/Admin/MagazaSorulari/index";
import UygulamaGeriBildirimleri from "../pages/Admin/UygulamaGeriBildirimleri/index";
import MagazaTakipcileri from "../pages/Admin/MagazaTakipcileri/index";
import MagazaFavorileri from "../pages/Admin/MagazaFavorileri/index";
import KayitliAramalar from "../pages/Admin/KayitliAramalar/index";
import IlanFiyatAlarmlari from "../pages/Admin/IlanFiyatAlarmlari/index";
import KategoriAbonelikleri from "../pages/Admin/KategoriAbonelikleri/index";
import IlanBegenileri from "../pages/Admin/IlanBegenileri/index";
import Sepetler from "../pages/Admin/Sepetler/index";
import SatinAlmaGecmisi from "../pages/Admin/SatinAlmaGecmisi/index";
import FcmTokenlari from "../pages/Admin/FcmTokenlari/index";
import Mesajlasmalar from "../pages/Admin/Mesajlasmalar/index";

// Pages Component
import Chat from "../pages/Chat/Chat";

// File Manager
import FileManager from "../pages/FileManager/index";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Pages Calendar
import Calendar from "../pages/Calendar/index";
import Serfikalarım from "../pages/Calendar/Sertifikalarim";
import Hesabim from "../pages/Calendar/Hesabim";

// //Tasks
import TasksList from "../pages/Tasks/tasks-list";
import TasksCreate from "../pages/Tasks/tasks-create";
import TasksKanban from "../pages/Tasks/tasks-kanban";

// //Projects
import ProjectsGrid from "../pages/Projects/projects-grid";
import ProjectsList from "../pages/Projects/projects-list";
import ProjectsOverview from "../pages/Projects/ProjectOverview/projects-overview";
import ProjectsCreate from "../pages/Projects/projects-create";

// //Ecommerce Pages
import EcommerceProducts from "../pages/Ecommerce/EcommerceProducts";
import EcommerceProductDetail from "../pages/Ecommerce/EcommerceDetails/index";
import KullaniciAktiviteleri from "../pages/Ecommerce/EcommerceDetails/index";

import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index";
import EcommerceCustomers from "../pages/Ecommerce/EcommerceCustomers/index";
import EcommerceCart from "../pages/Ecommerce/EcommerceCart";
import EcommerceCheckout from "../pages/Ecommerce/EcommerceCheckout";
import EcommerceShops from "../pages/Ecommerce/EcommerceShops/index";
import EcommerceAddProduct from "../pages/Ecommerce/EcommerceAddProduct";


import TalepDuzenle from '../pages/TalepDuzenle'; // Klasör yolunu kendine göre uyarla
//Email
import EmailInbox from "../pages/Email/email-inbox";
import EmailRead from "../pages/Email/email-read";
import EmailBasicTemplte from "../pages/Email/email-basic-templte";
import EmailAlertTemplte from "../pages/Email/email-template-alert";
import EmailTemplateBilling from "../pages/Email/email-template-billing";

//Invoices
import InvoicesList from "../pages/Invoices/invoices-list";
import InvoiceDetail from "../pages/Invoices/invoices-detail";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Login2 from "../pages/AuthenticationInner/Login2";
import Register1 from "../pages/AuthenticationInner/Register";
import Register2 from "../pages/AuthenticationInner/Register2";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import Recoverpw2 from "../pages/AuthenticationInner/Recoverpw2";
import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword";
import ForgetPwd2 from "../pages/AuthenticationInner/ForgetPassword2";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";
import LockScreen2 from "../pages/AuthenticationInner/auth-lock-screen-2";
import ConfirmMail from "../pages/AuthenticationInner/page-confirm-mail";
import ConfirmMail2 from "../pages/AuthenticationInner/page-confirm-mail-2";
import EmailVerification from "../pages/AuthenticationInner/auth-email-verification";
import EmailVerification2 from "../pages/AuthenticationInner/auth-email-verification-2";
import TwostepVerification from "../pages/AuthenticationInner/auth-two-step-verification";
import TwostepVerification2 from "../pages/AuthenticationInner/auth-two-step-verification-2";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import DashboardSaas from "../pages/Dashboard-saas/index";
import DashboardCrypto from "../pages/Dashboard-crypto/index";
import Blog from "../pages/Dashboard-Blog/index";
import DashboardJob from "../pages/DashboardJob/index";

//Crypto
import CryptoWallet from "../pages/Crypto/CryptoWallet/crypto-wallet";
import CryptoBuySell from "../pages/Crypto/crypto-buy-sell";
import CryptoExchange from "../pages/Crypto/crypto-exchange";
import CryptoLending from "../pages/Crypto/crypto-lending";
import CryptoOrders from "../pages/Crypto/CryptoOrders/crypto-orders";
import CryptoKYCApplication from "../pages/Crypto/crypto-kyc-application";
import CryptoIcoLanding from "../pages/Crypto/CryptoIcoLanding/index";

// Charts
import ChartApex from "../pages/Charts/Apexcharts";
import ChartjsChart from "../pages/Charts/ChartjsChart";
import EChart from "../pages/Charts/EChart";
import SparklineChart from "../pages/Charts/SparklineChart";
import ChartsKnob from "../pages/Charts/charts-knob";
import ReCharts from "../pages/Charts/ReCharts";

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle";

//Icons
import IconBoxicons from "../pages/Icons/IconBoxicons";
import IconDripicons from "../pages/Icons/IconDripicons";
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign";
import IconFontawesome from "../pages/Icons/IconFontawesome";

//Tables
import BasicTables from "../pages/Tables/BasicTables";
import DatatableTables from "../pages/Tables/DatatableTables";

//Blog
import BlogList from "../pages/Blog/BlogList/index";
import BlogGrid from "../pages/Blog/BlogGrid/index";
import BlogDetails from "../pages/Blog/BlogDetails";

//Job
import JobGrid from "../pages/JobPages/JobGrid/index";
import JobDetails from "../pages/JobPages/JobDetails";
import JobCategories from "../pages/JobPages/JobCategories";
import JobList from "../pages/JobPages/JobList";
import ApplyJobs from "../pages/JobPages/ApplyJobs/index";
import CandidateList from "../pages/JobPages/CandidateList";
import CandidateOverview from "../pages/JobPages/CandidateOverview";

// Forms
import FormElements from "../pages/Forms/FormElements";
import FormLayouts from "../pages/Forms/FormLayouts";
import FormAdvanced from "../pages/Forms/FormAdvanced";
import FormEditors from "../pages/Forms/FormEditors";
import FormValidations from "../pages/Forms/FormValidations";
import FormMask from "../pages/Forms/FormMask";
import FormRepeater from "../pages/Forms/FormRepeater";
import FormUpload from "../pages/Forms/FormUpload";
import FormWizard from "../pages/Forms/FormWizard";

//Ui
import UiAlert from "../pages/Ui/UiAlert";
import UiButtons from "../pages/Ui/UiButtons";
import UiCards from "../pages/Ui/UiCards";
import UiCarousel from "../pages/Ui/UiCarousel";
import UiColors from "../pages/Ui/UiColors";
import UiDropdown from "../pages/Ui/UiDropdown";
import UiGeneral from "../pages/Ui/UiGeneral";
import UiGrid from "../pages/Ui/UiGrid";
import UiImages from "../pages/Ui/UiImages";
import UiLightbox from "../pages/Ui/UiLightbox";
import UiModal from "../pages/Ui/UiModal";
import UiProgressbar from "../pages/Ui/UiProgressbar";
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions";
import UiTypography from "../pages/Ui/UiTypography";
import UiVideo from "../pages/Ui/UiVideo";
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout";
import UiRating from "../pages/Ui/UiRating";
import UiRangeSlider from "../pages/Ui/UiRangeSlider";
import UiNotifications from "../pages/Ui/ui-notifications";
import UiOffCanvas from "pages/Ui/UiOffCanvas";
import UiUtilitie from "../pages/Ui/UiUtilitie";
import UiPlaceholders from "../pages/Ui/UiPlaceholders";
import UiToasts from "../pages/Ui/UiToast";

//Pages
import PagesStarter from "../pages/Utility/pages-starter";
import PagesMaintenance from "../pages/Utility/pages-maintenance";
import PagesComingsoon from "../pages/Utility/pages-comingsoon";
import PagesTimeline from "../pages/Utility/pages-timeline";
import PagesFaqs from "../pages/Utility/pages-faqs";
import PagesPricing from "../pages/Utility/pages-pricing";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";

//Contacts
import ContactsGrid from "../pages/Contacts/contacts-grid";
import ContactsList from "../pages/Contacts/ContactList/contacts-list";
import ContactsProfile from "../pages/Contacts/ContactsProfile/contacts-profile";
import ExpenseEntry from "pages/JobPages/ExpenseEntry/ExpenseEntry";
import FinalOffer from "pages/JobPages/FinalOffer/FinalOffer";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/dashboard-saas", component: <DashboardSaas /> },
  { path: "/dashboard-crypto", component: <DashboardCrypto /> },
  { path: "/blog", component: <Blog /> },
  { path: "/dashboard-job", component: <DashboardJob /> },

  //Crypto
  { path: "/crypto-wallet", component: <CryptoWallet /> },
  { path: "/crypto-buy-sell", component: <CryptoBuySell /> },
  { path: "/crypto-exchange", component: <CryptoExchange /> },
  { path: "/crypto-lending", component: <CryptoLending /> },
  { path: "/crypto-orders", component: <CryptoOrders /> },
  { path: "/crypto-kyc-application", component: <CryptoKYCApplication /> },

  //chat
  { path: "/chat", component: <Chat /> },

  //File Manager
  { path: "/apps-filemanager", component: <FileManager /> },

  // //calendar
  { path: "/calendar", component: <Calendar /> },
  { path: "/sertifikalarim", component: <Serfikalarım /> },
  { path: "/hesabim", component: <Hesabim /> },

  // //profile
  { path: "/profile", component: <UserProfile /> },

  { path: "/kullanici-aktiviteleri/:id", component: <KullaniciAktiviteleri /> },
  //Ecommerce
   { path: "/ecommerce-product-detail/:id", component: <EcommerceProductDetail /> },
  { path: "/ecommerce-products", component: <EcommerceProducts /> },
  { path: "/ecommerce-orders", component: <EcommerceOrders /> },
  { path: "/ecommerce-customers", component: <EcommerceCustomers /> },
  { path: "/ecommerce-cart", component: <EcommerceCart /> },
  { path: "/ecommerce-checkout", component: <EcommerceCheckout /> },
  { path: "/ecommerce-shops", component: <EcommerceShops /> },
  { path: "/ecommerce-add-product", component: <EcommerceAddProduct /> },

  //Email
  { path: "/email-inbox", component: <EmailInbox /> },
  { path: "/email-read/:id?", component: <EmailRead /> },
  { path: "/email-template-basic", component: <EmailBasicTemplte /> },
  { path: "/email-template-alert", component: <EmailAlertTemplte /> },
  { path: "/email-template-billing", component: <EmailTemplateBilling /> },

  //Invoices
  { path: "/invoices-list", component: <InvoicesList /> },
  { path: "/invoices-detail/:id", component: <InvoiceDetail /> },
  { path: "/invoices-detail", component: <InvoiceDetail /> },

  // Tasks
  { path: "/tasks-list", component: <TasksList /> },
  { path: "/tasks-create", component: <TasksCreate /> },
  { path: "/tasks-kanban", component: <TasksKanban /> },

  //Projects
  { path: "/projects-grid", component: <ProjectsGrid /> },
  { path: "/projects-list", component: <ProjectsList /> },
  { path: "/projects-overview", component: <ProjectsOverview /> },
  { path: "/projects-overview/:id", component: <ProjectsOverview /> },
  { path: "/projects-create", component: <ProjectsCreate /> },

  //Blog
  { path: "/blog-list", component: <BlogList /> },
  { path: "/blog-grid", component: <BlogGrid /> },
  { path: "/blog-details", component: <BlogDetails /> },

    { path: "/expense-entry/:id", component: <ExpenseEntry /> },
  { path: "/final-offer/:id", component: <FinalOffer /> },
  { path: "/talep-duzenle/:id", component: <TalepDuzenle /> },

  // HarmanaGEL Admin Sayfaları
  { path: "/ilan-yonetimi", component: <IlanYonetimi /> },
  { path: "/kategori-yonetimi", component: <KategoriYonetimi /> },
  { path: "/kategori-ozellik-yonetimi", component: <KategoriOzellikYonetimi /> },
  { path: "/magaza-yonetimi", component: <MagazaYonetimi /> },
  { path: "/siparis-yonetimi", component: <SiparisYonetimi /> },
  { path: "/teslimat-yonetimi", component: <TeslimatYonetimi /> },
  { path: "/para-cekme-talepleri", component: <ParaCekmeTalepleri /> },
  { path: "/kullanici-cuzdanlari", component: <KullaniciCuzdanlari /> },
  { path: "/cuzdan-hareketleri", component: <CuzdanHareketleri /> },
  { path: "/iade-talepleri", component: <IadeTalepleri /> },
  { path: "/slider-yonetimi", component: <SliderYonetimi /> },
  { path: "/reklam-yonetimi", component: <ReklamYonetimi /> },
  { path: "/iletisim-mesajlari", component: <IletisimMesajlari /> },
  { path: "/sertifika-tanimlari", component: <SertifikaTanimlari /> },
  { path: "/mezat-yonetimi", component: <MezatYonetimi /> },
  { path: "/kullanici-sertifikalari", component: <KullaniciSertifikalari /> },
  { path: "/ilan-degerlemeleri", component: <IlanDegerlemeleri /> },
  { path: "/kullanici-haklari", component: <KullaniciHaklari /> },
  { path: "/blog-yonetimi", component: <BlogYonetimi /> },
  { path: "/ciftci-bilgi-menuleri", component: <CiftciBilgiMenuleri /> },
  { path: "/haber-kaynaklari", component: <HaberKaynaklari /> },
  { path: "/haber-yonetimi", component: <HaberYonetimi /> },
  { path: "/aktivasyon-analizi", component: <AktivasyonAnalizi /> },
  { path: "/etkilesim-raporu", component: <EtkilesimRaporu /> },
  { path: "/oturum-raporu", component: <OturumRaporu /> },
  { path: "/moderatorler", component: <Moderatorler /> },
  { path: "/paketler", component: <Paketler /> },
  { path: "/sss-yonetimi", component: <SSSYonetimi /> },
  { path: "/kullanici-kategori-haklari", component: <KullaniciKategoriHaklari /> },
  { path: "/kurban-siparis-yonetimi", component: <KurbanSiparisYonetimi /> },
  { path: "/odeme-yonetimi", component: <OdemeYonetimi /> },
  { path: "/fatura-bilgileri", component: <FaturaBilgileri /> },
  { path: "/kullanici-banka-bilgileri", component: <KullaniciBankaBilgileri /> },
  { path: "/engel-listesi", component: <EngelListesi /> },
  { path: "/ilan-teklifleri", component: <IlanTeklifleri /> },
  { path: "/degerleme-talepleri", component: <DegerlemeTalepleri /> },
  { path: "/hizmet-onay-basvurulari", component: <HizmetOnayBasvurulari /> },
  { path: "/hizmet-talebi-gir", component: <HizmetTalebiGir /> },
  { path: "/yorum-yonetimi", component: <YorumYonetimi /> },
  { path: "/sikayet-yonetimi", component: <SikayetYonetimi /> },
  { path: "/bildirim-gonder", component: <BildirimGonder /> },
  { path: "/odeme-loglari", component: <OdemeLoglari /> },
  { path: "/ilan-fiyat-log", component: <IlanFiyatLog /> },
  { path: "/ilan-goruntulenme-log", component: <IlanGoruntulenmeLog /> },
  { path: "/kurbanlik-hayvan-listesi", component: <KurbanlikHayvanListesi /> },
  { path: "/bildirim-loglari", component: <BildirimLoglari /> },
  { path: "/mezat-teklifleri", component: <MezatTeklifleri /> },
  { path: "/siparis-detaylari", component: <SiparisDetaylari /> },
  { path: "/kurbanlik-hisse-fiyatlari", component: <KurbanlikHisseFiyatlari /> },
  { path: "/sistem-ayarlari", component: <SistemAyarları /> },
  { path: "/sayfa-icerikleri", component: <SayfaIcerikleri /> },
  { path: "/kurumsal-bilgiler", component: <KurumsalBilgiler /> },
  { path: "/hizmet-sektorleri", component: <HizmetSektorleri /> },
  { path: "/isletme-hizmetleri", component: <IsletmeHizmetleri /> },
  { path: "/uzmanlar", component: <Uzmanlar /> },
  { path: "/uzman-degerlendirmeleri", component: <UzmanDegerlendirmeleri /> },
  { path: "/bilgi-videolari", component: <BilgiVideolari /> },
  { path: "/magaza-sorulari", component: <MagazaSorulari /> },
  { path: "/uygulama-geri-bildirimleri", component: <UygulamaGeriBildirimleri /> },
  { path: "/magaza-takipcileri", component: <MagazaTakipcileri /> },
  { path: "/magaza-favorileri", component: <MagazaFavorileri /> },
  { path: "/kayitli-aramalar", component: <KayitliAramalar /> },
  { path: "/ilan-fiyat-alarmlari", component: <IlanFiyatAlarmlari /> },
  { path: "/kategori-abonelikleri", component: <KategoriAbonelikleri /> },
  { path: "/ilan-begenileri", component: <IlanBegenileri /> },
  { path: "/sepetler", component: <Sepetler /> },
  { path: "/satin-alma-gecmisi", component: <SatinAlmaGecmisi /> },
  { path: "/fcm-tokenlari", component: <FcmTokenlari /> },
  { path: "/mesajlasmalar", component: <Mesajlasmalar /> },

  //job
  { path: "/job-grid", component: <JobGrid /> },
  { path: "/job-details/:id", component: <JobDetails /> },
  { path: "/job-categories", component: <JobCategories /> },
  { path: "/job-list", component: <JobList /> },
  { path: "/job-apply", component: <ApplyJobs /> },
  { path: "/candidate-list", component: <CandidateList /> },
  { path: "/candidate-overview", component: <CandidateOverview /> },

  // Contacts
  { path: "/contacts-grid", component: <ContactsGrid /> },
  { path: "/contacts-list", component: <ContactsList /> },
  { path: "/contacts-profile", component: <ContactsProfile /> },

  //Charts
  { path: "/apex-charts", component: <ChartApex /> },
  { path: "/chartjs-charts", component: <ChartjsChart /> },
  { path: "/e-charts", component: <EChart /> },
  { path: "/sparkline-charts", component: <SparklineChart /> },
  { path: "/charts-knob", component: <ChartsKnob /> },
  { path: "/re-charts", component: <ReCharts /> },

  // Icons
  { path: "/icons-boxicons", component: <IconBoxicons /> },
  { path: "/icons-dripicons", component: <IconDripicons /> },
  { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  { path: "/icons-fontawesome", component: <IconFontawesome /> },

  // Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-datatable", component: <DatatableTables /> },

  // Maps
  { path: "/maps-google", component: <MapsGoogle /> },

  // Forms
  { path: "/form-elements", component: <FormElements /> },
  { path: "/form-layouts", component: <FormLayouts /> },
  { path: "/form-advanced", component: <FormAdvanced /> },
  { path: "/form-editors", component: <FormEditors /> },
  { path: "/form-mask", component: <FormMask /> },
  { path: "/form-repeater", component: <FormRepeater /> },
  { path: "/form-uploads", component: <FormUpload /> },
  { path: "/form-wizard", component: <FormWizard /> },
  { path: "/form-validation", component: <FormValidations /> },

  // Ui
  { path: "/ui-alerts", component: <UiAlert /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-dropdowns", component: <UiDropdown /> },
  { path: "/ui-general", component: <UiGeneral /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-lightbox", component: <UiLightbox /> },
  { path: "/ui-modals", component: <UiModal /> },
  { path: "/ui-progressbars", component: <UiProgressbar /> },
  { path: "/ui-tabs-accordions", component: <UiTabsAccordions /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-video", component: <UiVideo /> },
  { path: "/ui-session-timeout", component: <UiSessionTimeout /> },
  { path: "/ui-rating", component: <UiRating /> },
  { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  { path: "/ui-notifications", component: <UiNotifications /> },
  { path: "/ui-offcanvas", component: <UiOffCanvas /> },
  { path: "/ui-utilities", component: <UiUtilitie /> },
  { path: "/ui-placeholders", component: <UiPlaceholders /> },
  { path: "/ui-toasts", component: <UiToasts /> },

  //Utility
  { path: "/pages-starter", component: <PagesStarter /> },
  { path: "/pages-timeline", component: <PagesTimeline /> },
  { path: "/pages-faqs", component: <PagesFaqs /> },
  { path: "/pages-pricing", component: <PagesPricing /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    component: <Navigate to="/dashboard" replace />,
  },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },

  { path: "/pages-maintenance", component: <PagesMaintenance /> },
  { path: "/pages-comingsoon", component: <PagesComingsoon /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },
  { path: "/crypto-ico-landing", component: <CryptoIcoLanding /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-login-2", component: <Login2 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/pages-register-2", component: <Register2 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/page-recoverpw-2", component: <Recoverpw2 /> },
  { path: "/pages-forgot-pwd", component: <ForgetPwd1 /> },
  { path: "/auth-forgot-pwd-2", component: <ForgetPwd2 /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  { path: "/auth-lock-screen-2", component: <LockScreen2 /> },
  { path: "/page-confirm-mail", component: <ConfirmMail /> },
  { path: "/page-confirm-mail-2", component: <ConfirmMail2 /> },
  { path: "/auth-email-verification", component: <EmailVerification /> },
  { path: "/auth-email-verification-2", component: <EmailVerification2 /> },
  { path: "/auth-two-step-verification", component: <TwostepVerification /> },
  { path: "/auth-two-step-verification-2", component: <TwostepVerification2 /> },
];

export { authProtectedRoutes, publicRoutes };
